import { render, staticRenderFns } from "./NotificacionConDocumentoGrid.vue?vue&type=template&id=4be11e3c"
import script from "./NotificacionConDocumentoGrid.vue?vue&type=script&lang=js"
export * from "./NotificacionConDocumentoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports